var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShrink = function SvgShrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.878 6.153V4.22a1.22 1.22 0 1 1 2.44 0v4.878a1.22 1.22 0 0 1-1.22 1.22H3.22a1.22 1.22 0 0 1 0-2.44h1.933L2.357 5.082a1.22 1.22 0 1 1 1.725-1.725zM18.164 7.878h1.934a1.22 1.22 0 0 1 0 2.44H15.22A1.22 1.22 0 0 1 14 9.097V4.22a1.22 1.22 0 0 1 2.439 0v1.933l2.796-2.796a1.22 1.22 0 0 1 1.725 1.725zM5.153 17.44H3.22a1.22 1.22 0 0 1 0-2.44h4.878c.673 0 1.22.546 1.22 1.22v4.878a1.22 1.22 0 0 1-2.44 0v-1.934L4.082 21.96a1.22 1.22 0 1 1-1.725-1.725zM16.439 19.164v1.934a1.22 1.22 0 0 1-2.439 0V16.22c0-.674.546-1.22 1.22-1.22h4.878a1.22 1.22 0 0 1 0 2.44h-1.934l2.796 2.795a1.22 1.22 0 0 1-1.725 1.725z",
    clipRule: "evenodd"
  })));
};
export default SvgShrink;